import { render } from "./About.vue?vue&type=template&id=5c0b037d&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=5c0b037d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c0b037d"

export default script